import { Avatar, Divider, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import { tokens } from "../../../store/tokens";

const RightContent = ({ testimonialData }) => {
  const { info, poster_info, poster_name, poster_pic, title, subtitle } =
    testimonialData;

  return (
    <Stack spacing={2.5} sx={{ width: "100%" }}>
      {subtitle && (
        <Typography
          sx={{
            fontFamily: tokens.font.body,
            fontSize: "0.75rem",
            fontWeight: 700,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: tokens.textOn.dark.brand,
          }}
        >
          {subtitle}
        </Typography>
      )}

      <Typography
        sx={{
          fontFamily: tokens.font.heading,
          fontSize: { xs: "1.15rem", md: "1.35rem" },
          fontWeight: 700,
          lineHeight: 1.4,
          color: tokens.textOn.dark.primary,
        }}
      >
        {title}
      </Typography>

      {info && (
        <Typography
          sx={{
            fontFamily: tokens.font.body,
            fontSize: "0.9375rem",
            fontWeight: 400,
            lineHeight: 1.75,
            color: tokens.textOn.dark.secondary,
          }}
        >
          {info}
        </Typography>
      )}

      <Divider sx={{ borderColor: "rgba(255,255,255,0.14)" }} />

      <Stack direction="row" spacing={1.75} alignItems="center">
        <Avatar
          alt={poster_name}
          src={poster_pic}
          sx={{
            width: { xs: 52, md: 56 },
            height: { xs: 52, md: 56 },
            border: `2px solid ${tokens.color.teal}`,
          }}
        />
        <Stack spacing={0.25}>
          <Typography
            sx={{
              fontFamily: tokens.font.body,
              fontSize: "0.95rem",
              fontWeight: 700,
              color: tokens.textOn.dark.primary,
            }}
          >
            {poster_name}
          </Typography>
          <Typography
            sx={{
              fontFamily: tokens.font.body,
              fontSize: "0.8125rem",
              color: tokens.textOn.dark.secondary,
            }}
          >
            {poster_info}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default RightContent;